import React from 'react';
import { TableCell } from '@mui/material';
import { formatCryptoCurrency } from '../../utils/formatNumber';

class GridCryptoAmountCell extends React.Component {
    render() {
        const value = this.props.value;
        const coin = this.props.row.coin?.coin;
        let formattedAmount = formatCryptoCurrency(value, coin);
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {formattedAmount}
            </TableCell>
        );
    }
}

export default GridCryptoAmountCell;
